import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionStatsRibbon } from './types';

export const SolutionCommercialStatsRibbon: React.FC<{
  ribbon: SolutionStatsRibbon;
}> = ({ ribbon }) => (
  <SiteSection id="impact" className="cl-stats-ribbon">
    <SiteSectionHeader
      eyebrow={ribbon.eyebrow}
      title={ribbon.title}
      subtitle={ribbon.subtitle}
      align="center"
    />

    <div className="cl-stats-ribbon__shell">
      <div className="cl-stats-ribbon__strip" role="list" aria-label={ribbon.title}>
        {ribbon.items.map((item, index) => (
          <React.Fragment key={item.label}>
            {index > 0 ? (
              <span className="cl-stats-ribbon__sep" aria-hidden>
                ●
              </span>
            ) : null}
            <div
              className={`cl-stats-ribbon__stat${
                item.value.length > 10 ? ' cl-stats-ribbon__stat--compact' : ''
              }`}
              role="listitem"
            >
              <span className="cl-stats-ribbon__stat-emoji" aria-hidden>
                {item.emoji}
              </span>
              <span className="cl-stats-ribbon__stat-value">{item.value}</span>
              <span className="cl-stats-ribbon__stat-label">{item.label}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  </SiteSection>
);
